import { makeStyles, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) => ({
  cellText: {
    fontWeight: "bold",
    lineHeight: '35px',
  },
}));

export const PayoffCardTotalCellText = observer(({ children }) => {
  const classes = useStyles();
  return (
    <Typography variant="body1" className={classes.cellText}>{children}</Typography>
  )
});